import * as React from 'react';
import './circlegraphcomponent.css'

interface CircleGraphComponentProps {
    type:string;
    percent:number;
}

const convertTypeToColor = {
    "mana":"#74a3f0",
    "damage":"#f3a5a5"
};

export default class CircleGraphComponent extends React.Component<CircleGraphComponentProps,any> {

    constructor(props:CircleGraphComponentProps){
        super(props);

        this.state = {
            circleRadius: 50,
        }
    }

    gp():CircleGraphComponentProps{
        return this.props
    }

    calculateCircumference(radius){
        return Math.round(2*(Math.PI)*radius)
    }

    calculateCircleStrokeLength(radius){
        let circumference = this.calculateCircumference(radius);
        return (this.gp().percent)*circumference;
    }

    getColorOfStroke(){
        return convertTypeToColor[this.gp().type];
    }

    getType(){
        if (this.gp().type == "mana"){
            return 'Your Mana'
        }
        return "Enemy's Health"
    }

    render(){
        return(
            <div className="container">
                <svg className="circle-graph-container">
                    <circle style={{r:`${this.state.circleRadius}px`}}
                            className="circle-graph-inner"
                    />
                </svg>
                <svg className="circle-graph-container">
                    <circle style={{strokeDasharray:`${this.calculateCircleStrokeLength(this.state.circleRadius)} ${this.calculateCircumference(this.state.circleRadius)}`,
                                    r:`${this.state.circleRadius}px`,
                                    stroke:this.getColorOfStroke()
                    }}
                            className="circle-graph-outer"
                    />
                </svg>
                <div className="circle-graph-container" >
                    <div className="text-container">
                        <div className="percent-text">
                            {`${((this.gp().percent)*100).toFixed(0)}%`}
                        </div>

                        <div className="subtext">
                            {`of ${this.getType()}`}
                        </div>
                    </div>

                </div>

            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/CircleGraphComponent/index.tsx